import axios from "axios";
import { ApiReqBaseUrl } from "../assets/GlobalVariables";

export const saveDynamicPackage = async (data) => {
  // Create API request for new hotel order
  try {
    return await axios.post(`${ApiReqBaseUrl}/saveDynamicPackage`, data);
  } catch (err) {
    console.log({ err });
  }
};

export const getDynamicOrder = async (data) => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicOrder`, data);
  } catch (err) {
    console.log({ err });
  }
};

export const getDynamicOrders = async (data) => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicOrdersByAgentId`, data);
  } catch (err) {
    console.log({ err });
  }
};

export const getDynamicHotelNames = async (agent_id) => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicHotelNames`, {
      agent_id,
    });
  } catch (err) {
    console.log({ err });
    return { data: [] };
  }
};

export const getDynamicAgentEmails = async () => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicAgentEmails`, {});
  } catch (err) {
    console.log({ err });
    return { data: [] };
  }
};
